export default "__VITE_ASSET__35e4a874__"